const tools = [
    {
        id: "1",
        title: "Crop Tool",
        icon: "crop",
        color: "#3B82F6",
        requiredTier: "Silver",
    },
    {
        id: "13",
        title: "Scientific Calculator",
        icon: "calculator",
        color: "#3B82F6",
        requiredTier: "Silver",
    },
    {
        id: "14",
        title: "BMI Calculator",
        icon: "heartbeat",
        color: "#10B981",
        requiredTier: "Silver",
    },
    {
        id: "2",
        title: "Word Counter",
        icon: "font",
        color: "#10B981",
        requiredTier: "Silver",
    },
    {
        id: "3",
        title: "PDF Scanner",
        icon: "file-pdf",
        color: "#F59E0B",
        requiredTier: "Gold",
    },
    {
        id: "4",
        title: "QR Code Generator",
        icon: "qrcode",
        color: "#8B5CF6",
        requiredTier: "Silver",
    },

    {
        id: "5",
        title: "QR Scanner",
        icon: "qrcode",
        color: "#22C55E",
        requiredTier: "Gold",
    },
    {
        id: "7",
        title: "Image Compress",
        icon: "compress-arrows-alt",
        color: "#6366F1",
        requiredTier: "Gold",
    },
    {
        id: "8",
        title: "Translator",
        icon: "language",
        color: "#EC4899",
        requiredTier: "Gold",
    },
    {
        id: "10",
        title: "Zip Creator",
        icon: "file-archive",
        color: "#F43F5E",
        requiredTier: "Platinum",
    },
    {
        id: "11",
        title: "Notes Pro",
        icon: "sticky-note",
        color: "#8B5CF6",
        requiredTier: "Platinum",
    },

    // ✅ NEW
    {
        id: "12",
        title: "Encoder / Decoder",
        icon: "code",
        color: "#0EA5E9",
        requiredTier: "Platinum",
    },

    {
        id: "15",
        title: "Loan Calculator",
        icon: "money-bill-wave",
        color: "#F59E0B",
        requiredTier: "Gold",
    },
    {
        id: "16",
        title: "Tip Calculator",
        icon: "hand-holding-usd",
        color: "#8B5CF6",
        requiredTier: "Silver",
    },
    {
        id: "17",
        title: "Currency Converter",
        icon: "exchange-alt",
        color: "#EF4444",
        requiredTier: "Platinum",
    },
    {
        id: "18",
        title: "Unit Converter",
        icon: "ruler-combined",
        color: "#6366F1",
        requiredTier: "Silver",
    },
    {
        id: "19",
        title: "Investment Calc",
        icon: "chart-line",
        color: "#EC4899",
        requiredTier: "Platinum",
    },
    {
        id: "20",
        title: "Discount Calc",
        icon: "percentage",
        color: "#14B8A6",
        requiredTier: "Gold",
    },
    {
        id: "21",
        title: "Fuel Cost Calc",
        icon: "gas-pump",
        color: "#F43F5E",
        requiredTier: "Platinum",
    },
    {
        id: "22",
        title: "Mortgage Calc",
        icon: "home",
        color: "#8B5CF6",
        requiredTier: "Platinum",
    },
];

export { tools }
